import { cn } from '@/utlis/cn'

type MenuButtonContentTitleProps = {
    text: string
    icon?: React.ComponentType<{ style?: React.CSSProperties }>
    className?: string
}
export function MenuButtonContentTitle(props: MenuButtonContentTitleProps) {
    return (
        <div className={cn('flex items-center t-base-bold gap-[12px]', props.className)}>
            {props.icon && <props.icon style={{ fontSize: '1.3rem' }} />} {props.text}
        </div>
    )
}
